// extracted by mini-css-extract-plugin
export default {"dialog":"SuccessInfoDialog_dialog__1ElKh","icon":"SuccessInfoDialog_icon__lo-N-","formButton":"SuccessInfoDialog_formButton__5Fir+"};